export default __webpack_public_path__ + "img/union_left.2b8378c4.svg";